import { Controller } from 'stimulus';
import localDb from '../helpers/localDb';

class CookieConsent extends Controller {
  connect() {
    if (!('localStorage' in window)) {
      return;
    }

    if (!localDb.get(this.data.get('name'))) {
      this.showCookieBar();
    }
  }

  onClose() {
    this.element.setAttribute('hidden', 'hidden');

    const lifetimeInMinutes = this.data.get('lifetime');

    localDb.set(this.data.get('name'), 1, lifetimeInMinutes * 60 * 1000);

    const tagManager = this.application.getControllerForElementAndIdentifier(document.documentElement, 'tag-manager');

    if (tagManager && typeof tagManager.onAcceptCookies === 'function') {
      tagManager.onAcceptCookies();
    }
  }

  showCookieBar() {
    this.element.removeAttribute('hidden');
  }
}

CookieConsent.targets = [
  //
];

export default CookieConsent;
